import { type PlanOrganizationTask, PlanOrganizationTaskName, PlanOrganizationTaskStatus } from '../../../models/PlanOrganizationTask'
import { DataTool } from './DataTool'
import { RCN_ANNUAL_ACTIVITIES_URL } from '../../../constants/gvsuLinks'

interface Props {
  planOrganizationTasks: PlanOrganizationTask[]
}
export const FocusStudentDataTool = (props: Props): JSX.Element => {
  const focusStudentDataBOYTask = props.planOrganizationTasks.find(t => t.taskName === PlanOrganizationTaskName.FocusStudentDataBOY)
  const focusStudentDataEOYTask = props.planOrganizationTasks.find(t => t.taskName === PlanOrganizationTaskName.FocusStudentDataEOY)

  return (
    <DataTool
      planOrganizationTaskId={focusStudentDataBOYTask?.id ?? 0}
      completed={focusStudentDataBOYTask?.status === PlanOrganizationTaskStatus.UpdatesSubmitted}
      title='Focus Student Data'
      dueDate={focusStudentDataEOYTask?.dueDate ?? new Date()}
      descriptor='Beginning of Year'
      secondaryPlanOrganizationTaskId={focusStudentDataEOYTask?.id ?? 0}
      secondaryCompleted={focusStudentDataEOYTask?.status === PlanOrganizationTaskStatus.UpdatesSubmitted}
      secondaryDescriptor='End of Year'
      showDescriptors
      instructionsUrl={RCN_ANNUAL_ACTIVITIES_URL}
      color='var(--green-700)'
      successMessage='Focus Student Data Updated'
      dataTestId='focusStudentDataTool'
    />
  )
}
